document.addEventListener("DOMContentLoaded", function() {

  const mobileMenuElems = document.querySelectorAll('.dropdown-toggle[data-toggle="dropdown-mobile"]');
  mobileMenuElems.forEach(function(mobileMenuElem) {

    mobileMenuElem.addEventListener('click', function(event) {
      event.preventDefault();
      mobileMenuElem.classList.toggle('toggled');

      const subMenu = document.querySelector(`.dropdown-mobile-menu[data-toggle-menu="${mobileMenuElem.getAttribute('title')}"]`);
      subMenu.classList.toggle('hidden');
      subMenu.classList.toggle('toggled');

      const toggledMenus = document.querySelectorAll('.dropdown-toggle[data-toggle="dropdown-mobile"].toggled');
      toggledMenus.forEach(function(toggledMenu) {
        if (toggledMenu !== mobileMenuElem) {
          toggledMenu.classList.remove('toggled');
        };
      });

      const toggledSubMenus = document.querySelectorAll('.dropdown-mobile-menu.toggled');
      toggledSubMenus.forEach(function(toggledSubMenu) {
        if (toggledSubMenu !== subMenu) {
          toggledSubMenu.classList.remove('toggled');
          toggledSubMenu.classList.add('hidden');
        }
      });
    });
  });
});
